import React from 'react'

/**
 * Upstrive mascot for the archive's "nothing here" states. Ids are namespaced
 * (archive-mascot-*) because inline SVG ids are page-global and the original
 * single-letter ids would collide with other icons. The pupils are wrapped so CSS
 * can give them a gentle glance (see .archive-mascot in Archive.css).
 */
export default function ArchiveMascot({ className = '' }) {
    return (
        <svg className={`archive-mascot ${className}`} viewBox="36 112 316 250" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#archive-mascot-a)">
                <g filter="url(#archive-mascot-b)">
                    <path
                        d="M279.08 188.281a24.55 24.55 0 0 0 6.11-12.328c.735-4.096-2.419-8.051-4.773-11.482a11.431 11.431 0 0 1-.864-1.49c-.805-1.664-1.597-3.379-2.791-4.79-1.035-1.223-2.247-2.789-2.959-4.162-1.791-3.459-2.698-4.598-2.286-7.712a3.22 3.22 0 0 1 1.001-1.978c1.893-1.786 4.594.257 5.449 2.715.058.168.122.33.2.489.466.947 2.313 4.39 4.425 4.144 2.566-.299.555-10.722-.673-16.16-.392-1.732.762-3.452 2.519-3.707a2.981 2.981 0 0 1 3.382 2.537l1.943 13.891c.083 1.37 2.159-.447 2.331-1.809.396-3.14 1.155-8.963 1.933-13.875.291-1.836 2.015-3.072 3.854-2.796a3.437 3.437 0 0 1 2.89 3.901l-2.331 15.792c-.162.907 2.043 2.27 2.657 1.201l5.914-12.253a3.484 3.484 0 0 1 6.348 2.867l-4.537 10.776a22.742 22.742 0 0 0-2.247 6.26c-.061.301-.117.602-.179.903-.249 1.198-.951 4.513-1.519 6.612-1.168 4.311-6.097 8.589-6.886 12.985l-2.237 12.462c-2.435 13.565-13.893 23.673-27.679 24.418-7.602.41-13.648-6.292-12.459-13.812l.945-5.975c8.626 1.517 16.999-1.626 22.519-7.624Z"
                        fill="url(#archive-mascot-c)"
                    />
                </g>
                <g filter="url(#archive-mascot-d)" transform="rotate(-6.643 173.294 207.327)">
                    <ellipse cx="173.294" cy="207.327" rx="100" ry="77.5" fill="url(#archive-mascot-e)" />
                    <ellipse cx="173.294" cy="207.327" rx="100" ry="77.5" fill="url(#archive-mascot-f)" fillOpacity="0.7" style={{ mixBlendMode: 'soft-light' }} />
                </g>
                <g filter="url(#archive-mascot-g)">
                    <path
                        d="M223.131 203.032c-7.62 12.008-24.371 22.974-47.35 25.65-22.98 2.677-41.802-4.146-51.978-14.081"
                        stroke="#8374CA"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
                <g>
                    <g>
                        <g filter="url(#archive-mascot-h)">
                            <ellipse cx="190.673" cy="183.657" rx="15" ry="20" transform="rotate(-6.643 190.673 183.657)" fill="#ECECEC" />
                        </g>
                        <g filter="url(#archive-mascot-i)">
                            <path d="M204.195 176.042s-4.413-13.581-15.836-12.25c-11.423 1.33-12.598 15.562-12.598 15.562 6.596-9.36 19.864-10.905 28.434-3.312Z" fill="#9183D2" />
                        </g>
                        <g transform="translate(0 -4)">
                            <g className="archive-mascot-pupil">
                                <ellipse cx="191.136" cy="187.63" rx="5" ry="7" transform="rotate(-6.643 191.136 187.63)" fill="#7060B6" />
                            </g>
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g filter="url(#archive-mascot-j)">
                            <ellipse cx="150.941" cy="188.285" rx="15" ry="20" transform="rotate(-6.643 150.941 188.285)" fill="#ECECEC" />
                        </g>
                        <g filter="url(#archive-mascot-k)">
                            <path d="M164.464 180.67s-4.414-13.581-15.837-12.25c-11.423 1.33-12.597 15.561-12.597 15.561 6.595-9.359 19.864-10.905 28.434-3.311Z" fill="#9183D2" />
                        </g>
                        <g transform="translate(0 -4)">
                            <g className="archive-mascot-pupil">
                                <ellipse cx="151.404" cy="192.258" rx="5" ry="7" transform="rotate(-6.643 151.404 192.258)" fill="#7060B6" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <defs>
                <filter id="archive-mascot-a" x="37.556" y="129.472" width="312.077" height="227.71" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="36" />
                    <feGaussianBlur stdDeviation="18" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3_724" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_3_724" result="shape" />
                </filter>
                <filter id="archive-mascot-b" x="255.466" y="129.729" width="59.167" height="88.981" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="1" dy="3" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0" />
                    <feBlend in2="shape" result="effect1_innerShadow_3_724" />
                </filter>
                <filter id="archive-mascot-d" x="73.556" y="129.472" width="200.477" height="158.71" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dx="1" dy="3" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0" />
                    <feBlend in2="shape" result="effect1_innerShadow_3_724" />
                </filter>
                <filter id="archive-mascot-g" x="120.803" y="201.032" width="105.329" height="32.234" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="0.5" />
                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3_724" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_3_724" result="shape" />
                </filter>
                <filter id="archive-mascot-h" x="159.593" y="158.714" width="62.16" height="71.886" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="11" />
                    <feGaussianBlur stdDeviation="8" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3_724" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_3_724" result="shape" />
                </filter>
                <filter id="archive-mascot-i" x="159.761" y="158.7" width="60.435" height="47.653" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="11" />
                    <feGaussianBlur stdDeviation="8" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3_724" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_3_724" result="shape" />
                </filter>
                <filter id="archive-mascot-j" x="119.861" y="163.342" width="62.16" height="71.886" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="11" />
                    <feGaussianBlur stdDeviation="8" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3_724" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_3_724" result="shape" />
                </filter>
                <filter id="archive-mascot-k" x="120.029" y="163.328" width="60.435" height="47.653" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="11" />
                    <feGaussianBlur stdDeviation="8" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3_724" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_3_724" result="shape" />
                </filter>
                <radialGradient id="archive-mascot-c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(100.176 93.14 186.068) scale(94.786 46.9597)">
                    <stop stopColor="#C7B5FB" />
                    <stop offset="1" stopColor="#6470DE" />
                </radialGradient>
                <radialGradient id="archive-mascot-e" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 155 -200 0 173.294 129.827)">
                    <stop offset="0.251" stopColor="#C7B5FB" />
                    <stop offset="1" stopColor="#505BBF" />
                </radialGradient>
                <radialGradient id="archive-mascot-f" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 77.5 -100 0 173.294 207.327)">
                    <stop stopColor="#fff" />
                    <stop offset="1" stopColor="#fff" stopOpacity="0" />
                </radialGradient>
            </defs>
        </svg>
    )
}
